import type { AppEvent } from 'src/common/events/appEvents';
import type { SteeringActionPayload, SteeringActionType, SteeringResponse } from '../types';

export type Action = {
  action: SteeringActionType;
  getHref(attributes: SteeringResponse['attributes'], clientId: string | null): string;
  getFollowUp(
    attributes: SteeringResponse['attributes'],
  ): { title: string; message: string } | null;
  completionEvents: AppEvent[];
  isOnActionPage(pathname: string, targetPathname: string): boolean;
};

type AttributesFor<T extends SteeringActionType> = Extract<
  SteeringActionPayload,
  { action: T }
>['attributes'];

type ActionConfig<T extends SteeringActionType> = {
  action: T;
  getHref(attributes: AttributesFor<T>, clientId: string | null): string;
  getFollowUp(attributes: AttributesFor<T>): { title: string; message: string } | null;
  completionEvents: AppEvent[];
  isOnActionPage?(pathname: string, targetPathname: string): boolean;
};

export function defineAction<T extends SteeringActionType>(config: ActionConfig<T>): Action {
  return {
    ...config,
    isOnActionPage:
      config.isOnActionPage ?? ((pathname, targetPathname) => pathname === targetPathname),
  };
}
